import * as React from "react";
const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    fill="none"
    viewBox="0 0 42 42"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.65}
        d="M12.111 25.444v6.667M21 25.444v6.667m8.889-6.667v6.667M1 41h40M1 16.556h40M1 9.889 21 1l20 8.889M3.222 16.556h35.556V41H3.222V16.556Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h42v42H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
